<div class="menu-mobile"
     #menu
>
  <div class="menu-mobile__overlay"
       (click)="tooglePopup()"
  ></div>
  <div class="menu-mobile__inner">
    <div class="menu-mobile__item"
         (click)="handleAction('settings')"
    >
      <stusan-icon icon="menu-settings"
                   style="width: 24px; height: 24px;"
      ></stusan-icon>
      <span class="menu-mobile__text">Settings</span>
    </div>
    <div class="menu-mobile__item"
         (click)="handleAction('invite')"
    >
      <stusan-icon icon="menu-invite"
                   style="width: 24px; height: 24px;"
      ></stusan-icon>
      <span class="menu-mobile__text">Invite</span>
    </div>
    <div class="menu-mobile__item"
         *ngIf="isRaiseHandEnabled"
         (click)="handleAction('raise')"
    >
      <stusan-icon icon="menu-hand"
                   style="width: 24px; height: 25px;"
      ></stusan-icon>
      <span class="menu-mobile__text">Raise hand</span>
    </div>
    <div class="menu-mobile__item"
         (click)="handleAction('recording')"
         *ngIf="customConfig.isRecordingEnabled"
    >
      <stusan-icon icon="menu-rec"
                   style="width: 24px; height: 25px;"
      ></stusan-icon>
      <span class="menu-mobile__text">
        {{ (recordingState$ | async) === 'recording' ? 'Stop recording' : 'Start recording' }}
      </span>
    </div>
    <a class="menu-mobile__item"
       [attr.href]="customConfig.feedbackUrl"
       target="_blank"
       (click)="handleAction('feedback')"
    >
      <stusan-icon icon="menu-feedback"
                   style="width: 24px; height: 26px;"
      ></stusan-icon>
      <span class="menu-mobile__text">Send feedback</span>
    </a>
  </div>
</div>
